/**
 * Blueprint for the standard address part of ticketing object.
 */
export class TicketingStandardAddress {
  public id: number;
  public salutation: string;
  public title: string;
  public firstName: string;
  public lastName: string;
  public street: string;
  public city: string;
  public postalCode: string;
  public country: string;
  public addressType: string;

  constructor(data?: any) {
    if (data === null) {
      return
    }

    this.id = data.id;
    this.salutation = data.salutation;
    this.title = data.title;
    this.firstName = data.firstName;
    this.lastName = data.lastName;
    this.street = data.street;
    this.city = data.city;
    this.postalCode = data.postalCode;
    this.country = data.country;
    this.addressType = data.addressType;
   }

}
